import React from 'react';
import PropTypes from 'prop-types';
import ConnectedPreviewReport from './ConnectedPreviewReport';

// TODO: Move to react-viewerbase

function PreviewReportRouting({ match }) {
  // TODO: Figure out which filters we want to pass in via a URL
  //const { patientId } = match.params;

  return <ConnectedPreviewReport />;
}

PreviewReportRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default PreviewReportRouting;
